import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

type DeleteIFRSQuestionResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: any;
};

export const DeleteIFRSQuestion = async (
  examId: string,
  questionId: string
): Promise<DeleteIFRSQuestionResponse> => {
  try {
    const response = await axios.delete(`/ifrs/${examId}/questions/${questionId}`);
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};

